import { Component, OnDestroy, OnInit, Type, ViewChild } from '@angular/core';
import { NbDialogService, NbPopoverDirective, NbSidebarService } from '@nebular/theme';
import { NbIconLibraries } from '@nebular/theme';
import { SitesPickerComponent } from '../editors/dialogs/sites-picker/sites-picker.component';
import { ColorPickerPopoverComponent } from '../editors/dialogs/color-picker-popover/color-picker-popover.component';
import { IntroSvgComponent } from '../editors/dialogs/intro-svg/intro-svg.component';
import { Subject, Subscription } from 'rxjs';
import { PreviewEditStoreService } from '../services/preview-edit-store.service';
import { Page, PageType, Site } from '../editor-container/editor-model';
import { takeUntil } from 'rxjs/operators';
import { IframeCommunicationService } from '../services/iframe-communication.service';
import { Router } from '@angular/router';

@Component({
  selector: 'kwe-editor-header',
  templateUrl: './editor-header.component.html',
  styleUrls: ['./editor-header.component.scss']
})
export class EditorHeaderComponent implements OnInit,OnDestroy {
  isPrimaryCollapsed:boolean;
  isSecondaryCollapsed:boolean = false;
  sitePickerPop:any = SitesPickerComponent;
  component: any = ColorPickerPopoverComponent;
  selectedSite$:Subscription;
  selectedPageType$:Subscription;
  selectedSite:Site;
  selectedPageType:PageType;

  @ViewChild(NbPopoverDirective) popover: NbPopoverDirective;

  private destroy$ = new Subject<void>();

  constructor(
    private sidebarService: NbSidebarService,
    private iconLibraries: NbIconLibraries,
    private dialogService: NbDialogService,
    private previewEditStoreService:PreviewEditStoreService,
    private communicator:IframeCommunicationService,
    private router:Router
    ) { 
      this.iconLibraries.registerFontPack('far', { packClass: 'far', iconClassPrefix: 'fa' });
    }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngOnInit(): void {
    this.selectedSite$ = this.previewEditStoreService.selectedSite$.pipe(takeUntil(this.destroy$))
    .subscribe((site:Site) => {
      this.selectedSite = site;
    })
    this.selectedPageType$ = this.previewEditStoreService.selectedPageType$.pipe(takeUntil(this.destroy$))
    .subscribe((pageType:PageType) => {
      console.log(pageType)
      this.selectedPageType = pageType;
    })
    this.sidebarService.getSidebarState('primary').subscribe(state => {
      console.log(this.isPrimaryCollapsed);
      if(state == "compacted"){
        this.isPrimaryCollapsed = false;
      }
    })
    this.sidebarService.getSidebarState('right').subscribe(state => {
      console.log("rightState: "+state);
      if(state == 'expanded'){
        this.isSecondaryCollapsed = false;
      }
      console.log(this.isSecondaryCollapsed);
    })
  }

  toggleSidebar(tag:string): boolean {
    console.log('sidebar toggled: '+tag);
    //this.sidebarService.toggle(false, 'menu-sidebar');
/*     
    if(this.isPrimaryCollapsed == undefined){
      this.sidebarService.getSidebarState('primary').subscribe(state => {
        if(state = "compacted"){
          this.sidebarService.collapse('primary');
          this.isPrimaryCollapsed = true;
        }
      })
    } */
    switch (tag) {
      case 'primary':
        if(this.isPrimaryCollapsed){
          this.sidebarService.compact('primary');
          this.isPrimaryCollapsed = false;
        }else{
          this.sidebarService.collapse('primary');
          this.isPrimaryCollapsed = true;
        }
        break;
      case 'right':
        if(this.isSecondaryCollapsed){
          this.sidebarService.expand('right');
          this.isSecondaryCollapsed = false;
        }else{
          this.sidebarService.collapse('right');
          this.isSecondaryCollapsed = true;
        }
        break;
    
      default:
        break;
    }    
    
   
    //this.sidebarService.collapse('primary');
    //this.layoutService.changeLayoutSize();

    return false;
  }

  playIntro(){
    let component:Type<any> = IntroSvgComponent;
    this.dialogService.open(component,{
      context:{
        
      }              
    })
  }
  snapShot(e){
    this.communicator.sendFromParent({id:"snapShot",data:"page"});
  }

  navigateHome(){

  }
  navigateLink(e){
    let link = e.target.attributes.getNamedItem("link");
    this.router.navigateByUrl(link.value);
  }

}
